const GUARANTEE_RETURNS_MAPPER = {
  afm: { key: 'afm', label: 'AFM' },
  status: {
    key: 'status',
    label: 'STATUS',
    options: [{ label: 'STATUS', value: 'status' }],
  },
  subscriptionId: { key: 'subscriptionId', label: 'SUBSCRIPTION ID' },
  type: { key: 'type', label: 'TYPE' },
  subDuration: { key: 'subDuration', label: 'SUB DURATION' },
  returnDate: { key: 'returnDate', label: 'RETURN-DATE' },
  plate: { key: 'plate', label: 'PLATE' },
  armTickets: { key: 'armTickets', label: 'ARM TICKETS' },
  billingTickets: { key: 'billingTickets', label: 'BILLING TICKETS' },
  guarantee: { key: 'guarantee', label: 'GUARANTEE' },
};

const INITIAL_GUARANTEE_RETURNS_GRID_COLUMNS = Object.values(
  GUARANTEE_RETURNS_MAPPER
).map(({ key, label }) => ({
  value: true,
  label,
  key,
}));

const INITIAL_GUARANTEE_RETURNS_COLUMN_VISIBILITY =
  INITIAL_GUARANTEE_RETURNS_GRID_COLUMNS?.reduce((acc, column) => {
    acc[column.key] = column.value;
    return acc;
  }, {});

// ΑΦΜ | SUB-ID | TYPE | SUB DURATION | RETURN-DATE | PLATE | ARM TICKETS (μόνο τα ανοιχτά) | BILLING TICKETS (μόνο τα ανοιχτά) | ΕΓΓΥΗΣΗ | STATUS
const DUMMY_RECORDS_COUNT = 50;

const createDummyRecord = (index) => {
  const id = `${index + 1}`;

  return {
    id,
    afm: 'ΑΦΜ',
    subscriptionId: `SUB-ID_${id}`,
    type: 'TYPE',
    subDuration: 'SUB DURATION',
    returnDate: 'RETURN-DATE',
    plate: 'PLATE',
    armTickets: `ARM_TICKETS_${id}`,
    billingTickets: `BILLING_TICKETS_${id}`,
    guarantee: 'ΕΓΓΥΗΣΗ',
    status: 'status',
  };
};

const dummyData = {
  data: Array.from({ length: DUMMY_RECORDS_COUNT }, (_, index) =>
    createDummyRecord(index)
  ),
  meta: { total: DUMMY_RECORDS_COUNT },
};

export {
  GUARANTEE_RETURNS_MAPPER,
  INITIAL_GUARANTEE_RETURNS_GRID_COLUMNS,
  INITIAL_GUARANTEE_RETURNS_COLUMN_VISIBILITY,
  dummyData,
};
